import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledButtonGroup = styled.div<{ $invalid?: boolean }>`
  ${tw`tw-flex tw-flex-row`}
  ${FontStyle}
  ${BoxSizingStyle}

  button {
    &:disabled {
      opacity: 1;
      color: var(--color-theme-500);
      pointer-events: none;
    }

    &:first-child:not(:last-child) {
      svg {
        margin-right: -4px;
      }
      ${tw`tw--mr-px tw-rounded-r-none`}
      ${(props) =>
        props.$invalid &&
        css`
          border-top-color: var(--red-alert) !important;
          border-bottom-color: var(--red-alert) !important;
          border-left-color: var(--red-alert) !important;
        `}
    }

    &:last-child:not(:first-child) {
      svg {
        margin-left: -4px;
      }
      ${tw`tw-rounded-l-none`}
      ${(props) =>
        props.$invalid &&
        css`
          border-top-color: var(--red-alert) !important;
          border-bottom-color: var(--red-alert) !important;
          border-right-color: var(--red-alert) !important;
        `}
    }

    &:not(:first-child):not(:last-child) {
      ${tw`tw--mr-px tw-rounded-none`}
      ${(props) =>
        props.$invalid &&
        css`
          border-top-color: var(--red-alert) !important;
          border-bottom-color: var(--red-alert) !important;
        `}
    }
  }

  svg {
    ${tw`tw-text-theme-900 tw-fill-current`}
  }
`;

StyledButtonGroup.displayName = "StyledButtonGroup";
